// extracted by mini-css-extract-plugin
export default {"rating":"ZK-z","numberOfStars":"_K-z","count":"aL-z","barGraphSpacing":"bL-z","barGraph":"cL-z"};